


















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import userApi from "@/api/userApi";
import User from "@/model/user";
@Component({
  name: "qUserSelect",
  components: {},
  directives: {},
})
export default class QUserSelect extends Vue {
  public users: User[] = [];
  public selected = null;

  @Prop({
    default: null,
  })
  companyId;
  @Prop({
    default: null,
  })
  witnessId;
  @Prop({
    default: null,
  })
  affiliationCompanyId;
  @Prop()
  value;
  @Prop({
    default: null,
  })
  roleId;
  @Prop({ default: false})
  notLoading
  @Watch('value')
  updateValue() {
    this.selected = this.value;
  }
  @Watch("companyId")
  changeCompanyId(newValue) {
    if (newValue) {
      // this.selected = null;
      this.getList();
    } else {
      this.users = [];
    }
  }
  @Watch("witnessId")
  changeWitnessId(newValue) {
    if (newValue) {
      this.getList();
    } else {
      this.users = [];
    }
  }

  @Watch("affiliationCompanyId")
  changeAffiliationCompanyId(newValue) {
    if (newValue) {
      this.getList();
    } else {
      this.users = [];
    }
  }

  mounted() {
    if (this.companyId || this.affiliationCompanyId) {
      this.getList();
    }
    this.selected = this.value;
  }

  public changed() {
    this.$emit("input", this.selected);
  }

  public async getList() {
    let data = {};
    if (this.notLoading) {
      data['notLoading'] = true;
    }
    const result = await userApi.index({
      company_id: this.companyId,
      affiliation_company_id: this.affiliationCompanyId,
      role_id: this.roleId,
    }, data);
    if (result) {
      this.users = result;
    }
  }
}
